import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { SettingIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/points-management/points-configuration')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="pointManagement.sidebar.menu.pointsConfiguration" icon={SettingIcon} />,
      title: <Translation id="pointManagement.sidebar.menu.pointsConfiguration" />,
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
